import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

export const CampusFitnessDetails = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div>
        {/* Start Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h1>Campus Fitness Center</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">
                  <Link to="/campus">Campus</Link>
                </li>
                <li className="navspace">Fitness Center</li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Page Banner */}

        {/* <!--Start Academic Details Area--> */}
        <div className="academics-details-area pt-100 pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="academics-details">
                  <div className="details">
                    <h2>Get Fit, Stay Healthy</h2>
                    <p>
                      Fitness is key to overall well-being. Whether you're
                      looking to lose weight, build muscle, or just feel better,
                      exercise is the foundation of a healthy lifestyle.
                    </p>

                    <div className="details-images">
                      <div className="row">
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/campusfit1.webp" width={6000} height={4000} 
                            alt="Image"
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/campusfit3.webp"
                            alt="Image"
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/campusfit2.webp"
                            alt="Image"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="prepare-exam">
                    <h3>Transform Your Body and Mind</h3>
                    <p>
                      Fitness is not just about physical appearance; it’s about
                      enhancing mental health and building resilience. Regular
                      exercise improves mood, reduces stress, and helps you feel
                      confident and strong.
                    </p>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Benefits of Regular Exercise</h4>
                          <p>
                            Engaging in regular physical activity boosts heart
                            health, enhances mental clarity, and increases
                            energy levels, contributing to a happier, healthier
                            life.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Building a Fitness Routine</h4>
                          <p>
                            Establishing a consistent fitness routine is
                            essential for progress. Start with manageable goals,
                            focusing on a mix of strength, cardio, and
                            flexibility.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Nutrition and Fitness</h4>
                          <p>
                            What you eat plays a critical role in achieving
                            fitness goals. A balanced diet with proper protein,
                            healthy fats, and vitamins fuels the body for
                            optimal performance.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Staying Motivated</h4>
                          <p>
                            Staying committed to fitness requires persistence.
                            Set small, achievable targets and celebrate progress
                            to maintain motivation and track your growth.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--End Academic Details Area--> */}
      </div>
    </>
  );
};
